/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DeliverFeeWarehouseStepRespVo } from './DeliverFeeWarehouseStepRespVo';
import {
    DeliverFeeWarehouseStepRespVoFromJSON,
    DeliverFeeWarehouseStepRespVoFromJSONTyped,
    DeliverFeeWarehouseStepRespVoToJSON,
    DeliverFeeWarehouseStepRespVoToJSONTyped,
} from './DeliverFeeWarehouseStepRespVo';
import type { DeliverFeeWarehouseAmountRespVo } from './DeliverFeeWarehouseAmountRespVo';
import {
    DeliverFeeWarehouseAmountRespVoFromJSON,
    DeliverFeeWarehouseAmountRespVoFromJSONTyped,
    DeliverFeeWarehouseAmountRespVoToJSON,
    DeliverFeeWarehouseAmountRespVoToJSONTyped,
} from './DeliverFeeWarehouseAmountRespVo';

/**
 * 
 * @export
 * @interface DeliverFeeWarehouseGradeRespVo
 */
export interface DeliverFeeWarehouseGradeRespVo {
    /**
     * 用户等级id
     * @type {number}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    gradeId?: number;
    /**
     * 用户等级名称-中文
     * @type {string}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    gradeNameCn?: string;
    /**
     * 用户等级名称-韩文
     * @type {string}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    gradeNameKr?: string;
    /**
     * 明细渲染模式：STEP 步长规则（国际），RANGE 区间明细（韩国国内）
     * @type {string}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    ruleMode?: string;
    /**
     * 
     * @type {DeliverFeeWarehouseStepRespVo}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    stepRule?: DeliverFeeWarehouseStepRespVo;
    /**
     * 韩国国内区间-金额明细（ruleMode=RANGE 返回全部，国际运费为空）
     * @type {Array<DeliverFeeWarehouseAmountRespVo>}
     * @memberof DeliverFeeWarehouseGradeRespVo
     */
    ranges?: Array<DeliverFeeWarehouseAmountRespVo>;
}

/**
 * Check if a given object implements the DeliverFeeWarehouseGradeRespVo interface.
 */
export function instanceOfDeliverFeeWarehouseGradeRespVo(value: object): value is DeliverFeeWarehouseGradeRespVo {
    return true;
}

export function DeliverFeeWarehouseGradeRespVoFromJSON(json: any): DeliverFeeWarehouseGradeRespVo {
    return DeliverFeeWarehouseGradeRespVoFromJSONTyped(json, false);
}

export function DeliverFeeWarehouseGradeRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliverFeeWarehouseGradeRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'] == null ? undefined : json['gradeId'],
        'gradeNameCn': json['gradeNameCn'] == null ? undefined : json['gradeNameCn'],
        'gradeNameKr': json['gradeNameKr'] == null ? undefined : json['gradeNameKr'],
        'ruleMode': json['ruleMode'] == null ? undefined : json['ruleMode'],
        'stepRule': json['stepRule'] == null ? undefined : DeliverFeeWarehouseStepRespVoFromJSON(json['stepRule']),
        'ranges': json['ranges'] == null ? undefined : ((json['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoFromJSON)),
    };
}

export function DeliverFeeWarehouseGradeRespVoToJSON(json: any): DeliverFeeWarehouseGradeRespVo {
    return DeliverFeeWarehouseGradeRespVoToJSONTyped(json, false);
}

export function DeliverFeeWarehouseGradeRespVoToJSONTyped(value?: DeliverFeeWarehouseGradeRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'gradeNameCn': value['gradeNameCn'],
        'gradeNameKr': value['gradeNameKr'],
        'ruleMode': value['ruleMode'],
        'stepRule': DeliverFeeWarehouseStepRespVoToJSON(value['stepRule']),
        'ranges': value['ranges'] == null ? undefined : ((value['ranges'] as Array<any>).map(DeliverFeeWarehouseAmountRespVoToJSON)),
    };
}

